































import { Component, Vue } from "vue-property-decorator";
import Textfield from "@/components/Textfield.vue";
import Button from "@/components/Button.vue";
import Logo from "@/components/Logo.vue";

@Component({
  components: {
    appLogo: Logo,
    appTextfield: Textfield,
    appButton: Button
  }
})
export default class ForgotPassword extends Vue {
  email = "";
  error = "";
  submitted = false;

  onSubmit(): void {
    this.axios.post("/api/auth/forgot-password", { email: this.email });
    this.submitted = true;
  }
}
